import { useDeleteApplicationDocumentMutation } from '@graphql/index';
import { Box } from '@spark-web/box';
import { DocumentTextIcon, XIcon } from '@spark-web/icon';
import { Text } from '@spark-web/text';
import { TextLink } from '@spark-web/text-link';
import { useApplicationDocumentUrl } from '../../hooks';

const UploadedDocumentsLink = ({ documentId, fileName, applicationId, onRemoveDocument, onRestoreDocument }) => {
  const { data: downloadUrl } = useApplicationDocumentUrl({
    applicationDocumentGetPresignedUrlInput: {
      applicationId,
      documentId,
    },
  });
  const { mutate } = useDeleteApplicationDocumentMutation();
  const handleRemoveDocument = (documentId: string) => {
    onRemoveDocument(documentId);
    mutate(
      {
        deleteApplicationDocumentInput: {
          applicationId,
          documentId,
        },
      },
      {
        onError: () => {
          onRestoreDocument(documentId, fileName);
        },
      },
    );
  };
  return (
    <>
      {downloadUrl ? (
        <Box key={documentId} border="field" borderRadius="small" padding="xsmall">
          <Box display="flex" alignItems="center" gap="medium" height="medium" paddingLeft="small">
            <DocumentTextIcon size="xsmall" />
            <Box flex={1}>
              <Text>
                <TextLink href={downloadUrl}>{fileName}</TextLink>
              </Text>
            </Box>
            <Box
              as="button"
              type="button"
              cursor="pointer"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="small"
              height="medium"
              width="medium"
              onClick={() => handleRemoveDocument(documentId)}
            >
              <XIcon size="xxsmall" />
            </Box>
          </Box>
        </Box>
      ) : null}
    </>
  );
};

export default UploadedDocumentsLink;
